import styled from "styled-components";

export const Container = styled.div`
  height: 100vh;
  display: grid;
  grid-template-rows: var(--navbar-height) 1fr;
`;

export const Content = styled.div`
  position: relative;
  overflow-x: auto;
  overflow-y: auto;
  height: calc(100vh - var(--navbar-height));
  background-color: #f4f6f9;
  padding: 30px;
`;
